import React, { HTMLProps, useEffect, useRef, useState } from 'react';

import { ControlLabel, InputGroup } from 'react-bootstrap';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import { DateUtils, DayPickerProps } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import dateFnsFormat from 'date-fns/format';
import dateFnsParse from 'date-fns/parse';

import '../../../styles/containers/Event.css';

function parseDate(str, format, locale) {
  const parsed = dateFnsParse(str, format, new Date(), { locale });
  if (DateUtils.isDate(parsed)) {
    return parsed;
  }
  return undefined;
}

function formatDate(date, format, locale) {
  return dateFnsFormat(date, format, { locale });
}

type Props = {
  value: Date;
  handleChange(date?: Date): void;
  label?: string;
  placeholder?: string;
  inputProps?: HTMLProps<HTMLInputElement>;
  dayPickerProps?: DayPickerProps;
  isClearable?: boolean;
};

const DatePicker = ({
  label,
  value,
  placeholder = 'MM/DD/YYYY',
  inputProps,
  dayPickerProps,
  handleChange,
  isClearable = true,
}: Props) => {
  const ref = useRef<HTMLInputElement>(null);
  const [selected, setSelected] = useState<Date>(value);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;
    node.blur();
  }, []);

  useEffect(() => {
    setSelected(value);
  }, [value]);

  return (
    <>
      {label && <ControlLabel>{label}</ControlLabel>}
      <div className='day-picker-inp'>
        <InputGroup>
          <DayPickerInput
            value={selected}
            format={'P'}
            placeholder={placeholder}
            component={props => <input ref={ref} {...props} />}
            formatDate={formatDate}
            inputProps={{ ...inputProps, readOnly: true }}
            dayPickerProps={{ ...dayPickerProps, enableOutsideDaysClick: true }}
            parseDate={parseDate}
            onDayChange={handleChange}
          />
          <InputGroup.Addon>
            <i className='fas fa-calendar-alt' />
          </InputGroup.Addon>
        </InputGroup>
        {isClearable && (
          <span
            onClick={() => handleChange(undefined)}
            className='my-clear-icon'
          >
            {value && <i className='fas fa-times' />}
          </span>
        )}
      </div>
    </>
  );
};
export default DatePicker;
